module.exports = __webpack_public_path__ + "/images/monitorizacion-precios-wishlist-IT.d9d0702.webp";